import { Experiment } from '@amplitude/experiment-js-client';
import { env } from '@/constants';
import type { FeatureFlagProviderService } from '@arcual/lib-app-platform';

export class AmplitudeFeatureFlagService implements FeatureFlagProviderService {
  private initialized = true;
  private experiment;

  constructor() {
    this.experiment = Experiment.initializeWithAmplitudeAnalytics(env.VITE_AMPLITUDE_CLIENT_KEY);
  }

  async initialize() {
    try {
      await this.experiment.start();
      this.initialized = true;
    } catch {
      this.initialized = false;
    }
  }

  public isHealthy(): boolean {
    return this.initialized;
  }

  public isFeatureEnabled(key: string): boolean {
    return this.experiment.variant(key)?.value === 'on';
  }
}
